'use client';
import { useEffect, useState } from 'react';
import { Input, Select, Button, Form } from 'antd';
import styles from '../footer.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFSMS from '@/components/UI/svg/Footer/Icon/EFSMS';
import EFTick from '@/components/UI/svg/Footer/Icon/EFTick';
import EfModal from '@/components/UI/Modal';
import { areaCountriesList, createSubscribeSms } from '@/service';
import { localValueMap } from '@/utils/locals';
import { getPrivacyPolicy } from '@/utils/common';

import { useLang } from '@/i18n';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';

const phoneValid = /^\d{11,15}$/;

const SMSForm = ({ locale, email, theme, setSmsSuccess }: { locale: string; email: string; theme: string; setSmsSuccess: any }) => {
    const { setGlobalContext, subEmailCount, isMobile, Link } = useGlobal();
    const [inputMsg, setInputMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [inputTipClassName, setInputTipClassName] = useState('line-h-3');
    const [open, setOpen] = useState(false);
    const { t } = useLang('shared');
    const [options, setOptions] = useState([]);
    const [areaValue, setAreaValue] = useState<{ id: string; value: string; originCode: string } | undefined>(undefined);
    const [value, setValue] = useState(undefined);
    const [form] = Form.useForm();

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        form.validateFields().then((valid) => {
            if (valid) {
                setOpen(true);
            }
        });
    };

    const getAreaCountriesList = async (data = {}) => {
        const res = await areaCountriesList(data, locale);

        if (res.code === '0' && res.data && res.data?.content?.length > 0) {
            const list = res.data.content.map((item: any) => {
                const originCode = item.phoneCode;
                if (item.phoneCode.includes('and')) {
                    const phoneStr = item.phoneCode.split(' and ')[0];
                    item.phoneCode = phoneStr;
                }
                return { label: item.name, value: item.phoneCode, key: item.id, id: item.id, originCode };
            });
            setOptions(list);
        } else {
            setOptions([]);
        }
    };

    const handleAreaChange = (val, option) => {
        setValue(val);
        setAreaValue(option);
    };

    const handleConfirm = () => {
        setOpen(false);
        form.validateFields().then(async (valid) => {
            if (valid) {
                const phone = areaValue?.originCode ? areaValue?.originCode + valid.phoneNum : valid.phoneNum;
                const subscribeRes = await createSubscribeSms(
                    {
                        email,
                        phone,
                        eventTracking: subscribeCookie({
                            entry_name: 'footer',
                        }),
                    },
                    locale,
                );
                if (subscribeRes?.code === '0') {
                    setInputMsg('');
                    setInputTipClassName('');
                    setSuccessMsg(t('sms_subscription.sms_phone_thank'));
                    // setInputTipClassName('input-msg-au');
                    setSmsSuccess(t('sms_subscription.sms_phone_thank'));
                    form.resetFields();
                } else {
                    setInputMsg(subscribeRes.message);
                    setSuccessMsg('');
                }
            }
        });
    };

    const getDefaultArea = async (data = {}) => {
        const res = await areaCountriesList(data, locale);
        console.log('res', res);

        if (res.code === '0' && res.data && res.data?.content?.length > 0) {
            const list = res.data.content.map((item: any) => {
                const originCode = item.phoneCode;
                if (item.phoneCode.includes('and')) {
                    const phoneStr = item.phoneCode.split(' and ')[0];
                    item.phoneCode = phoneStr;
                }
                return { label: item.name, value: item.phoneCode, id: item.id, originCode };
            });

            if (list?.length) {
                const defaultArea = list[0];
                handleAreaChange({ ...defaultArea, key: defaultArea.value, label: defaultArea.value }, { ...defaultArea });
            } else {
                handleAreaChange(undefined, undefined);
            }
        } else {
            handleAreaChange(undefined, undefined);
        }
    };

    useEffect(() => {
        const nationName = localValueMap[locale].region;
        getAreaCountriesList();
        setInputMsg('');
        setSuccessMsg(t('sms_subscription.sms_phone_thank_byemail'));
        setTimeout(() => {
            getDefaultArea({ name: nationName });
        }, 500);
    }, []);

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                `}
            </style>
            <div className="right">
                <div className="sms-form">
                    <Form className="sub" form={form}>
                        <div className="sms-form-item">
                            <div className="sms-container-div">
                                <Input.Group compact className="sms-container">
                                    <Select
                                        className="area-select"
                                        showArrow={false}
                                        options={options}
                                        optionLabelProp="value"
                                        optionFilterProp="label"
                                        labelInValue
                                        value={value}
                                        placeholder={t('sms_subscription.sms_phone_select_code')}
                                        showSearch
                                        onChange={handleAreaChange}
                                    ></Select>
                                    <Form.Item
                                        name="phoneNum"
                                        rules={[
                                            {
                                                validator: (_: any, value: string) => {
                                                    if (!value) {
                                                        setSuccessMsg('');
                                                        setInputMsg(t('sms_subscription.sms_phone_hint1'));
                                                        return Promise.reject();
                                                    }

                                                    const newAreaCode =
                                                        typeof areaValue === 'object' && areaValue.value ? areaValue.value.replace(/[+-]/g, '') : '';

                                                    if (!phoneValid.test(newAreaCode + value)) {
                                                        setSuccessMsg('');
                                                        setInputMsg(t('sms_subscription.sms_phone_hint2'));
                                                        return Promise.reject();
                                                    }
                                                    setSuccessMsg('');
                                                    setInputMsg('');
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <Input className="phone-input" placeholder={t('sms_subscription.sms_phone_place')} />
                                    </Form.Item>
                                    <Button
                                        icon={<EFSMS className="form-email" bg={theme !== 'black' ? '#fff' : ''} />}
                                        className="sms-btn"
                                        onClick={handleSubmit}
                                    ></Button>
                                </Input.Group>
                            </div>
                            {inputMsg && <div className={`input-msg`}>{inputMsg}</div>}
                            {successMsg && (
                                <div className={`success-msg input-msg-au success ${inputTipClassName}`}>
                                    <EFTick /> {successMsg}
                                </div>
                            )}
                            <div className="result"></div>
                        </div>
                    </Form>
                </div>
                <EfModal open={open} visible={open} width={isMobile ? '100%' : 600} onCancel={() => setOpen(false)}>
                    <div className={styles['protocol-modal-sms']}>
                        <p>{t('sms_subscription.sms_phone_modal_desc1')}</p>
                        <br />
                        <p>
                            {t.rich('sms_subscription.sms_phone_modal_desc2', {
                                privacy: (text: string) => (
                                    <Link className="link" href={getPrivacyPolicy(locale)}>
                                        {text}
                                    </Link>
                                ),
                                terms: (text: string) => (
                                    <Link className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`}>
                                        {text}
                                    </Link>
                                ),
                            })}
                        </p>
                        <Button type="primary" className="confirm-btn" onClick={handleConfirm}>
                            {t('sms_subscription.sms_phone_confirm')}
                        </Button>
                    </div>
                </EfModal>
            </div>
        </>
    );
};

export default SMSForm;
